document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.about-tabs');

  sections.forEach(function (section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('.about-tabs__tab'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('.about-tabs__panel'));

    if (!tabs.length || !panels.length) return;

    function activate(index, focusTab) {
      tabs.forEach(function (tab, i) {
        var isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        var isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      if (focusTab) {
        tabs[index].focus();
        tabs[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index, false);
      });

      tab.addEventListener('keydown', function (event) {
        var newIndex = null;

        switch (event.key) {
          case 'ArrowRight':
            newIndex = (index + 1) % tabs.length;
            break;
          case 'ArrowLeft':
            newIndex = (index - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        activate(newIndex, true);
      });
    });
  });
});